import React from 'react';
import { newToastMessage } from '@Containers/ToastMessages/ToastMessagesActions';
import { InfoToastMessageTitle, InfoToastMessageContent } from '@Containers/ToastMessages/InfoToastMessage/InfoToastMessage';

// eslint-disable-next-line import/prefer-default-export
export const showInfoToastMessage = ({ title, content }) =>
  newToastMessage({
    iconId: '#icon-information',
    // eslint-disable-next-line react/jsx-filename-extension
    ...(title && { title: <InfoToastMessageTitle title={title} /> }),
    ...(content && { content: <InfoToastMessageContent content={content} /> }),
    className: 'els-toast-message info-toast-message',
    closeBtn: true,
  });
